import {
  jb_teaser_block_css_default
} from "./chunk.HFH3GAG2.js";
import {
  Spaceable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.P6YYTXAQ.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ChangesBackgroundColor
} from "./chunk.DOB66LDT.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  e,
  n,
  r as r2
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-teaser-block/jb-teaser-block.ts
var JbTeaserBlock = class extends Spaceable(ChangesBackgroundColor(r)) {
  constructor() {
    super(...arguments);
    this._shownTeasersCount = 0;
  }
  firstUpdated() {
    const curatedTeasers = this._slottedChildren.filter((element) => !element.getAttribute("randomized"));
    const randomTeasers = this._slottedChildren.filter((element) => element.getAttribute("randomized"));
    const randomizedRandomTeasers = this.shuffle(randomTeasers);
    randomizedRandomTeasers.forEach((teaser, index) => {
      if (index > this.teaserCount - curatedTeasers.length - 1) {
        teaser.style.setProperty("display", "none");
      }
    });
    const shownTeasers = this._slottedChildren.filter(
      (element) => element.style.getPropertyValue("display") !== "none"
    );
    this._shownTeasersCount = shownTeasers.length;
  }
  shuffle(array) {
    let currentIndex = array.length;
    let randomIndex;
    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }
    return array;
  }
  _enableAnimation() {
    return !(document.querySelector("jb-info-page-hero")?.parentElement?.nextElementSibling?.querySelector("jb-teaser-block") === this);
  }
  _getContentSpacingProperties() {
    return {
      colsMdUp: 12,
      type: "teaser-block"
    };
  }
  get _slottedChildren() {
    return this._slot.assignedElements({ flatten: true });
  }
  _tracking(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "teaser-block"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return ke`<section>
      ${(this.headline || this.subline) && ke`
          <div class="headline">
            ${this.headline && ke`<jb-section-headline .headline=${this.headline}></jb-section-headline>`}
            ${this.subline && ke`<p class="subline">${this.subline}</p>`}
          </div>
        `}
      <div class=${Rt({
      content: true,
      "teaser-slot": true,
      four: this._shownTeasersCount === 4,
      campaign: this.parentElement.nodeName === "JB-CAMPAIGN-PAGE-HERO"
    })}>
        <slot></slot>
      </div>
      <div class="content button-slot">
        <slot name="button" @jb-link:clicked=${this._tracking}></slot>
      </div>
    </div>
  </section>`;
  }
};
JbTeaserBlock.styles = jb_teaser_block_css_default;
__decorateClass([
  n()
], JbTeaserBlock.prototype, "background", 2);
__decorateClass([
  n()
], JbTeaserBlock.prototype, "headline", 2);
__decorateClass([
  n()
], JbTeaserBlock.prototype, "subline", 2);
__decorateClass([
  n({ type: Number })
], JbTeaserBlock.prototype, "teaserCount", 2);
__decorateClass([
  e(".row")
], JbTeaserBlock.prototype, "_row", 2);
__decorateClass([
  r2()
], JbTeaserBlock.prototype, "_shownTeasersCount", 2);
__decorateClass([
  e("slot")
], JbTeaserBlock.prototype, "_slot", 2);
JbTeaserBlock = __decorateClass([
  customElement("jb-teaser-block")
], JbTeaserBlock);

export {
  JbTeaserBlock
};
